export * from './Link'
export {default as NavyLink} from './NavyLink'
export {default as WhiteLink} from './WhiteLink'



// WEBPACK FOOTER //
// ./src/core/typography/link/index.js